import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import SimpleDropdown from "../components/SimpleDropdown";
import {
  organisation as organisationMapping,
  llm as llmMapping,
} from "../components/Mapping";
import { FileUploadSearch } from "../components/Fileupload";
import {
  Card,
  FullCard,
  Select,
  Accordion,
  Spinner,
  Button,
} from "../components/CommonComponents";
import { FaFileExcel, FaHtml5, FaImage, FaRegFilePdf, FaRegImage } from "react-icons/fa";
import {
  BsFileEarmarkPdf,
  BsFiletypeDocx,
  BsFiletypeMp3,
  BsFiletypeTxt,
} from "react-icons/bs";
import VKeyboard from "../components/vkeyboard2";
import axios from "axios";
import { franc } from "franc";
import ISO6391 from "iso-639-1";
import { FaPhotoVideo } from "react-icons/fa";
import { FaKeyboard } from "react-icons/fa";
import {
  mmsSearch,
  mmsSearchSpeech,
  mmsSearchFeedback,
  mmsSearchTeri,
  mmsExternal,
  mmsSearchFeedbackTeri,
  mmsFileSearchTeri,
  mmsTeriFileURL,
  mmsTeriStreaming,
  mmsSpeak,
} from "../api/serverAPI";
import { TbFileTypePpt } from "react-icons/tb";
import { GrDocumentZip } from "react-icons/gr";
import { IoMdMic } from "react-icons/io";
import { BsRecordFill } from "react-icons/bs";
import { HiMiniPauseCircle, HiMiniSpeakerWave } from "react-icons/hi2";
import { LuCopy } from "react-icons/lu";
import { AiFillLike } from "react-icons/ai";
import { AiFillDislike } from "react-icons/ai";
import { LuX } from "react-icons/lu";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import questionIcon from "../assets/questionIcon.svg";
import ansIcon from "../assets/ansIcon.svg";
import { enterpriseSearchEngine } from "../api/serverAPI";
import { useCookies } from "react-cookie";
import { EseAnswer } from "../components/EseAnswer";
import { CiGlobe } from "react-icons/ci";

const EnterpriseSearch = () => {
  const initialOrg = organisationMapping[0].text;
  const [repoType, setRepoType] = useState("teri");
  const [organisation, setOrganisation] = useState(initialOrg);
  const [keyboardLang, setKeyboardLang] = useState("english");
  const [llm, setLlm] = useState(llmMapping[initialOrg][0].text);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const textareaRef = useRef(null);
  const [query, setQuery] = useState("");
  const [databases, setDatabases] = useState({
    docs: false,
    image: false,
    audio: false,
    video: false,
  });
  const [audioUrl, setAudioUrl] = useState(null);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const [followUpTeri, setFollowUpTeri] = useState("");
  const [teriLinks, setTeriLinks] = useState(null);
  const [databasesTeri, setDatabasesTeri] = useState([]);
  const [base64Data, setBase64Data] = useState([]);
  const [responseAnswer, setResponseAnswer] = useState("");
  const [historyresponseAnswer, historySetResponseAnswer] = useState("");
  const [links, setLinks] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fullMessageHistory, setFullMessageHistory] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [image, setImage] = useState(false);
  const [imageQuestion, setImageQuestion] = useState([]);
  const [teriImageUrl, setTerImageUrl] = useState("");
  const [textQuery, setTextQuery] = useState("");
  const [feedbackTxt, setFeedbackTxt] = useState("");
  const [feedbackInput, setFeedbackInput] = useState("");
  const [language, setLanguage] = useState("en");
  const [isRecording, setIsRecording] = useState(false);
  const [activeIcon, setActiveIcon] = useState("");
  const [rating, setRating] = useState("none");
  const [base, setBase] = useState([]);
  const [showPopover, setShowPopover] = useState(false);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [base64AudioUrl, setBase64AudioUrl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [popoverStates, setPopoverStates] = useState({});
  const [modalStates, setModalStates] = useState({});
  const [openKeyboardModal, setOpenKeyboardModal] = useState(false);
  const [responses, setResponses] = useState([]);
  const [teriReferences, setTeriReferences] = useState([]);
  const [storedResponse, setStoredResponse] = useState([]);
  const [firstQuery, setFirstQuery] = useState("");
  const [followQuery, setFollowQuery] = useState("none");
  const [followUpQuestion, setFollowUpQuestion] = useState("");
  const [index, setIndex] = useState(0);
  const [selectedRadioButton, setSelectedRadioButton] = useState("question");
  const [selectedDatabase, setSelectedDatabase] = useState("krtrimaIQ");
  const [cookiesMail] = useCookies();
  const [docsCount, setDocsCount] = useState(1);
  const [currentQuestion, setCurrentQuestion] = useState("");
  const [currentAnswer, setCurrentAnswer] = useState("");
  const [data, setData] = useState([]);
  const chatContainerRef = useRef(null);
  const [cookies, setCookie] = useCookies(["jwtToken"]);
  const jwtToken = cookies["jwtToken"];
  const [error, setError] = useState(null);
  const [streaming, setStreaming] = useState(true);
  const [external, setExternal] = useState(false);
  const previousRepoType = useRef(null);
  const [uploadedPdf, setUploadedPdf] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [pdfDisplay, setPDFDisplay] = useState([]);
  const [base64PdfData, setBase64PdfData] = useState([]);
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [openKeyboard, setOpenKeyboard] = useState(false);

  useEffect(() => {
    if (previousRepoType.current === "oup" && repoType === "external") {
      setFirstQuery("");
    }
    previousRepoType.current = repoType;
  }, [repoType]);

  function getCodeByTextLLM(list, text) {
    let result = null;
    Object.values(list).map((category) => {
      const match = category.find((item) => item.text === text);
      if (match) {
        result = match.code;
      }
    });
    return result;
  }
  function getCodeByTextOrg(arr, text) {
    const match = arr.find((item) => item.text === text);
    return match ? match.code : null;
  }
  const callEnterpriseSearchAPI = async () => {
    if (currentQuestion.trim() === "") {
      setErrorMessage("Question cannot be empty");
      setLoading(false);
    } else {
      setStreaming(true);
      setLoading(true);
      setErrorMessage("");
      const sp = new URLSearchParams();
      sp.set(`query`, currentQuestion);
      sp.set("sender", jwtToken);
      sp.set(`vectorStore`, selectedDatabase);
      sp.set(`model`, getCodeByTextOrg(organisationMapping, organisation)); //organisation
      sp.set("modelName", getCodeByTextLLM(llmMapping, llm)); //model name

      const url = new URL("wss://enterprise.krtrimaiq.ai/ask_docs");
      // const url = new URL("ws://91.203.132.127:6003/ask_docs");
      url.search = sp.toString();
      const ws = new WebSocket(url);

      let first = true;
      ws.onmessage = (ev) => {
        const data = JSON.parse(ev.data);
        if (data.last_msg) {
          setStreaming(false);
          return;
        }
        const answer = data[0]?.text;

        // FIXME: DRY
        setData((prevData) => {
          const last = first ? {} : prevData[prevData.length - 1] || {};
          if (!first) prevData = prevData.slice(0, -1);
          first = false;
          if (data[0]?.text) last.text = data[0].text;
          if (Array.isArray(data)) {
            last.displayDocs = Boolean(
              Array.isArray(data[0]) ? data[0][0]?.Document : data[0]?.Document
            );
            last.docs = data;
          }
          return [...prevData, { question: currentQuestion, ...last }];
        });

        // Update the current answer
        setCurrentAnswer(answer);

        // Clear the current question
        setCurrentQuestion("");

        setLoading(false);
      };
    }
  };

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const scrollHeight = textareaRef.current.scrollHeight;
      if (scrollHeight <= parseInt(window.innerHeight * 0.2)) {
        textareaRef.current.style.height = `${scrollHeight}px`;
        textareaRef.current.style.overflowY = "hidden";
      } else {
        textareaRef.current.style.height = "20vh";
        textareaRef.current.style.overflowY = "auto";
      }
    }
  }, [query]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setDatabases((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    let uploadedPdf = false;
    const previews = files.map((file) => {
      if (file.type === "application/pdf") {
        uploadedPdf = true;
        setDatabasesTeri(["docs"]);
        return { type: "pdf", name: file.name, url: URL.createObjectURL(file) };
      } else {
        setDatabasesTeri(["image"]);
        return URL.createObjectURL(file);
      }
    });

    setImagePreviews(previews);
    setPDFDisplay(previews);

    if (uploadedPdf) {
      setUploadedPdf(true);
    }

    if (files.length > 0) {
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result.split(",")[1];
          setBase64Data((prev) => [...(prev || []), base64String]);
          setBase64PdfData((prev) => [...(prev || []), base64String]);
        };
        reader.readAsDataURL(file);
      });
    }
    event.target.value = null;
  };

  const handleRemoveFile = async (index) => {
    if (repoType === "teri") {
      const payload = {
        query: "",
        user_id: cookiesMail.email,
        file: base64PdfData[0],
        cancel: true,
        upload: uploadedPdf,
      };

      try {
        const response = await mmsFileSearchTeri(payload);
      } catch (error) {
        console.error("Error removing file from Teri:", error);
      }
    }

    if (index < 0 || index >= selectedFiles.length) {
      console.error("Invalid index for file removal:", index);
      setPDFDisplay([]);
      setBase64PdfData([]);
      return;
    }

    const removedFile = selectedFiles[index];
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);

    const updatedPreviews = imagePreviews.filter((_, i) => i !== index);
    setImagePreviews(updatedPreviews);

    setBase64Data((prev) => prev.filter((_, i) => i !== index));

    if (removedFile?.type === "application/pdf") {
      const hasOtherPdfs = updatedFiles.some(
        (file) => file.type === "application/pdf"
      );
      if (!hasOtherPdfs) {
        setCancel(true);
      }
    }
  };

  const teriLink = (link, name) => {
    const modifiedLink = link.replace("file://", "");
    setTeriLinks({ modifiedLink, modifiedName: name });
  };

  const sendTeriLinks = async (data) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      file_path: data.modifiedLink,
      filename: data.modifiedName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        "https://mlmachine.krtrimaiq.ai:5608/download",
        requestOptions
      );
      const blob = await response.blob();
      const pdfUrl = URL.createObjectURL(blob);
      setTerImageUrl(pdfUrl);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error sending Teri links:", error);
    } finally {
      setTeriLinks(null);
    }
  };

  useEffect(() => {
    if (teriLinks) {
      sendTeriLinks(teriLinks);
    }
  }, [teriLinks]);

  const getIconByExtension = (file_name, file_url) => {
    const cleanExtension = file_name
      .split(".")
      .pop()
      .toLowerCase()
      .replace(/[^a-z0-9]/, "");
    switch (cleanExtension) {
      case "pdf":
        return <FaRegFilePdf color="#23479F" size="2em" />;
      case "docx":
        return <BsFiletypeDocx color="#23479F" size="2em" />;
      case "txt":
        return <BsFiletypeTxt color="#23479F" size="2em" />;
      case "xlsx":
        return <FaFileExcel color="#23479F" size="2em" />;
      case "ppt":
        return <TbFileTypePpt color="#23479F" size="2em" />;
      case "mp3":
      case "wav":
        return <BsFiletypeMp3 color="#23479F" size="2em" />;
      case "html":
        return <FaHtml5 color="#23479F" size="2em" />;
      case "zip":
        return <GrDocumentZip color="#23479F" size="2em" />;
      case "png":
      case "jpg":
      case "jpeg":
        return (
          <>
            {repoType === "oup" ? (
              <img
                src={file_url}
                alt={file_name}
                style={{
                  width: "40px",
                  height: "40px",
                  objectFit: "contain",
                }}
              />
            ) : repoType === "teri" ? (
              <FaImage color="#23479F" size="2em" />
            ) : null}
          </>
        );

      case "mp4":
      case "vid":
      case "avi":
        return <FaPhotoVideo color="#23479F" size="2em" />;
      default:
        return <CiGlobe color="#23479F" size="2em" />;
    }
  };

  const overlayStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    width: "100vw",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    zIndex: 1000,
  };
  const getIconColor = (iconName) =>
    activeIcon === iconName ? "text-blue" : "text-gray-600";
  const currentAudio = useRef(null);
  const handleVoice = async (index, lang, e) => {
    var text = document.getElementsByClassName("responseanswer-" + index)[0]
      .innerText;

    setStoredResponse((prevResponses) =>
      prevResponses.map((item, i) => ({
        ...item,
        audioPlaying: i === index ? !item.audioPlaying : false, // Toggle only the clicked index
      }))
    );

    // Stop previous audio if playing
    if (currentAudio.current) {
      currentAudio.current.pause();
      currentAudio.current.currentTime = 0;
    }

    try {
      const response = await fetch("https://languageapi.krtrimaiq.ai:5502/speech", {
        method: "POST",
        body: JSON.stringify({
          text: text,
          language: lang,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const blob = await response.blob();
      const audioUrl = URL.createObjectURL(blob);

      const audioElement = new Audio(audioUrl);
      currentAudio.current = audioElement; // Store reference

      audioElement.play();

      audioElement.addEventListener("ended", () => {
        URL.revokeObjectURL(audioUrl);
        setStoredResponse((prevResponses) =>
          prevResponses.map((item, i) => ({
            ...item,
            audioPlaying: i === index ? false : item.audioPlaying,
          }))
        );
      });
    } catch (error) {
      console.error("Error playing audio:", error);
    }
  };

  const handleStop = (index) => {
    setStoredResponse((prevResponses) =>
      prevResponses.map((item, i) => ({
        ...item,
        audioPlaying: i === index ? false : item.audioPlaying,
      }))
    );

    if (currentAudio.current) {
      currentAudio.current.pause();
      currentAudio.current.currentTime = 0;
      currentAudio.current = null; // Clear reference
    }
  };

  const handleCopy = (index) => {
    const feedbackTextElement = document.querySelector(`.responseanswer-${index}`);
    
    if (!feedbackTextElement) {
      console.error("Element not found");
      return;
    }
  
    const feedbackText = feedbackTextElement.innerText;
  
    navigator.clipboard
      .writeText(feedbackText)
      .then(() => console.log("Copied successfully!"))
      .catch((error) => console.error("Copy failed:", error));
  };
  
  
  const handleLike = async () => {
    setActiveIcon("like");
    setErrorMessage("Thanks for Providing Feedback!");

    const selectedDatabases = Object.keys(databases).filter(
      (db) => databases[db]
    );
    let payload = {
      query: textQuery,
      databases:
        selectedDatabases.length > 0
          ? selectedDatabases
          : ["docs", "image", "audio", "video"],
      response: responseAnswer,
      feedback: 5,
    };

    if (imageQuestion.length > 0 && base.length > 0) {
      payload = {
        query: base[0],
        query_1: textQuery,
        databases: ["image_image"],
        response: responseAnswer,
        feedback: 5,
      };
    }

    try {
      let response;
      if (repoType === "oup") {
        response = await mmsSearchFeedback(payload);
      } else if (repoType === "teri") {
        response = await mmsSearchFeedbackTeri(payload);
      }
    } catch (error) {
      console.error("Error in handleLike:", error);
    } finally {
      setActiveIcon("");
      setErrorMessage("");
    }
  };
  const handleSubmit = async () => {
    if (!query.trim()) {
      setErrorMessage("Question cannot be empty");
      return;
    }

    if (repoType === "") {
      setErrorMessage("Select Repository Type");
      return;
    }

    setErrorMessage("");
    setImageQuestion([]);
    setTextQuery(query);

    let currentFirstQuery = firstQuery || query;
    let currentFollowQuery = firstQuery ? query : "";

    if (!firstQuery) setFirstQuery(query);
    if (firstQuery) setFollowQuery(query);

    setBase(base64Data);
    setImage(false);
    setActiveIcon("");

    let payload = {};

    if (repoType === "oup" || repoType === "teri") {
      const selectedDatabases = Object.keys(databases).filter(
        (db) => databases[db]
      );

      payload = {
        query,
        databases:
          selectedDatabases.length > 0
            ? selectedDatabases
            : ["docs", "image", "audio", "video"],
        feedback: "none",
        model: getCodeByTextOrg(organisationMapping, organisation),
        modelName: getCodeByTextLLM(llmMapping, llm),
      };

      if (repoType === "teri") {
        payload.language = language;
      }

      if (
        repoType === "oup" &&
        imagePreviews.length > 0 &&
        base64Data.length > 0
      ) {
        payload = {
          query: base64Data[0],
          query_1: query,
          databases: ["image_image"],
          feedback: "none",
          model: getCodeByTextOrg(organisationMapping, organisation),
          modelName: getCodeByTextLLM(llmMapping, llm),
        };
        setImageQuestion(imagePreviews);
      } else if (
        repoType === "teri" &&
        pdfDisplay.length > 0 &&
        base64PdfData.length > 0
      ) {
        payload = {
          query,
          user_id: cookiesMail.email,
          databases: databasesTeri,
          file: base64PdfData[0],
          cancel: cancel,
          upload: uploadedPdf,
        };
      }
    } else if (repoType === "external") {
      payload = {
        query: currentFirstQuery,
        follow_up_query: currentFollowQuery,
        model: getCodeByTextOrg(organisationMapping, organisation),
        modelName: getCodeByTextLLM(llmMapping, llm),
      };
    }

    setLoading(true);

    try {
      let response;
      let newResponseEntry = {};

      if (repoType === "oup" || repoType === "teri") {
        const apiCall =
          repoType === "teri" &&
            pdfDisplay.length > 0 &&
            base64PdfData.length > 0
            ? mmsFileSearchTeri
            : repoType === "oup"
              ? mmsSearch
              : mmsSearchTeri;

        response = await apiCall(payload);
        const {
          answer = ["Answer Not Found"],
          url = [],
          follow_up_questions: followQuestion = [],
        } = response.data;
        let sourcesLinks = [];

        if (repoType === "oup") {
          sourcesLinks = Array.isArray(answer[1])
            ? answer[1]
              .map((source) =>
                source?.file_name && source?.url
                  ? {
                    link: source.url.trim(),
                    displayText: source.file_name.trim(),
                  }
                  : null
              )
              .filter(Boolean)
            : [];
        } else {
          sourcesLinks = Array.isArray(url)
            ? url
              .map((source) =>
                source?.file_name && source?.url
                  ? {
                    link: source.url.trim(),
                    displayText: source.file_name.trim(),
                  }
                  : null
              )
              .filter(Boolean)
            : [];
        }

        setResponseAnswer(answer[0]);

        newResponseEntry = {
          index,
          question: query,
          answer: answer[0],
          followUpQuestion: followQuestion[0],
          links: sourcesLinks,
          imageQuestion: imagePreviews.length > 0 ? imagePreviews : [],
        };

        if (imagePreviews.length > 0) {
          setImagePreviews(imagePreviews);
          setImage(true);
        }
      } else if (repoType === "external") {
        response = await mmsExternal(payload);
        const { answer, follow_up_questions: followQuestion = [] } =
          response.data;

        setResponseAnswer(
          answer || followQuestion.join(", ") || "No data available"
        );

        newResponseEntry = {
          index,
          question: query,
          answer: answer || "No data available",
          followUpQuestion: followQuestion,
          links: [],
        };
      }

      setResponses((prevResponses) => [...prevResponses, newResponseEntry]);
      setIndex((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.error("Error in handleSubmit:", error.message || error);
    } finally {
      setLoading(false);
      setQuery("");
      setUploadedPdf(false);
      setSelectedFiles([]);
      setBase64Data([]);
      setImagePreviews([]);
      setImage(false);
      setFollowQuery("");
    }
  };

  useEffect(() => {
    if (language === "en") {
      setKeyboardLang("english");
    } else if (language === "hi") {
      setKeyboardLang("hindi");
    }
  }, [language]);

  const handleDislike = async (feedback) => {
    setActiveIcon("dislike");
    setLoading(true);

    const selectedDatabases = Object.keys(databases).filter(
      (db) => databases[db]
    );
    const defaultDatabases = ["docs", "image", "audio", "video"];

    let payload = {
      query: textQuery,
      databases:
        selectedDatabases.length > 0 ? selectedDatabases : defaultDatabases,
      response: responseAnswer,
      feedbackResponse: feedback,
      feedback: 0,
    };

    if (imageQuestion.length > 0 && base.length > 0) {
      payload = {
        ...payload,
        query: base[0],
        query_1: textQuery,
        databases: ["image_image"],
      };
    } else if (
      repoType === "teri" &&
      pdfDisplay.length > 0 &&
      base64PdfData.length > 0
    ) {
      payload = {
        ...payload,
        query: textQuery,
        databases: databasesTeri,
      };
    }

    try {
      const feedbackFunction =
        repoType === "teri" ? mmsSearchFeedbackTeri : mmsSearchFeedback;
      const response = await feedbackFunction(payload);

      const {
        answer = ["Answer Not Found"],
        follow_up_questions: followQuestion = [],
      } = response.data;

      const sourcesLinks = Array.isArray(answer[1])
        ? answer[1]
          .map((source) =>
            source?.file_name && source?.url
              ? {
                link: source.url.trim(),
                displayText: source.file_name.trim(),
              }
              : null
          )
          .filter(Boolean)
        : [];

      const newResponseEntry = {
        index,
        question: textQuery,
        answer: repoType === "oup" || repoType === "teri" ? answer[0] : answer,
        followUpQuestion: followQuestion,
        links: sourcesLinks,
        imageQuestion: repoType === "teri" ? pdfDisplay : imageQuestion,
      };

      setResponseAnswer(newResponseEntry.answer);
      setResponses((prevResponses) => [...prevResponses, newResponseEntry]);
      setIndex((prevIndex) => prevIndex + 1);
    } catch (error) {
      console.error("Error in handleDislike:", error);
    } finally {
      setActiveIcon("");
      setLoading(false);
    }
  };

  const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
  let recognition;

  if (SpeechRecognition) {
    recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
  } else {
    alert("Speech Recognition API is not supported in this browser.");
  }

  const handleMicClick = () => {
    if (recognition) {
      recognition.start();

      recognition.onstart = () => { };

      recognition.onspeechend = () => {
        recognition.stop();
      };

      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setQuery((prevQuery) => `${prevQuery} ${transcript}`);
      };

      recognition.onerror = (event) => {
        console.error("Speech recognition error detected: ", event.error);
        recognition.stop();
      };
    }
  };

  const togglePopover = (index) => {
    setPopoverStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const toggleModal = (index) => {
    setModalStates((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const closeModal = (index) => {
    setModalStates((prev) => ({
      ...prev,
      [index]: false,
    }));
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error("Error accessing microphone:", error);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);

      mediaRecorderRef.current.onstop = () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/mpeg",
        });
        const audioURL = URL.createObjectURL(audioBlob);
        setAudioUrl(audioURL);
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64Audio = reader.result.split(",")[1];
          const base64AudioUrl = base64Audio.toString();
          setBase64AudioUrl(base64AudioUrl);
          sendAudioToServer(base64AudioUrl);
        };
        reader.readAsDataURL(audioBlob);
      };
    }
  };

  const sendAudioToServer = async (base64AudioUrl) => {
    try {

      const payload = {
        language_id: language,
        file_data: base64AudioUrl,
      };
      const response = await mmsSpeak(payload);
      const transcriptionText = response.data
      setQuery(transcriptionText.transcription)

    } catch (error) {
      console.error("Error sending audio to server:", error);
    }
  };

  // const handleRecordingClick = () => {
  //   console.log(isRecording)
  //   if (isRecording) {
  //     stopRecording();
  //   } else {
  //     startRecording();
  //   }
  // };
  // const [isRecording, setIsRecording] = useState(false);
  const recognitionRef = useRef(null);

  const handleRecordingClick = async () => {

    if (language == 'hi') {
      try {
        const base64Audio = await recordAudio(); // Capture audio as base64

        const response = await fetch("https://languageapi.krtrimaiq.ai:5602/speech_text", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            language_id: "hi",
            file_data: base64Audio,
          }),
        });

        const data = await response.json();
        setQuery((prev) => (prev ? prev + " " + data.transcription[0] : data.transcription[0]));
        // recognitionRef.current.stop(); // Stop recording if it's running
        setIsRecording(false);
      } catch (error) {
        console.error("Error in Hindi translation:", error);
        // recognitionRef.current.stop(); // Stop recording if it's running
        setIsRecording(false);
      }
    } else {

      if (!("webkitSpeechRecognition" in window)) {
        alert("Speech recognition is not supported in this browser.");
        return;
      }

      const SpeechRecognition =
        window.webkitSpeechRecognition || window.SpeechRecognition;

      if (!recognitionRef.current) {
        recognitionRef.current = new SpeechRecognition();
        recognitionRef.current.continuous = false;
        recognitionRef.current.interimResults = false;

        recognitionRef.current.onresult = async (event) => {
          const transcript = event.results[0][0].transcript;
          setQuery((prev) => (prev ? prev + " " + transcript : transcript));

        };

        recognitionRef.current.onerror = (event) => {
          console.error("Speech recognition error:", event.error);
          setIsRecording(false); // Stop recording on error
        };

        recognitionRef.current.onend = () => {
          setIsRecording(false); // Ensure UI updates when recording stops
        };
      }

      if (isRecording) {
        recognitionRef.current.stop(); // Stop recording if it's running
        setIsRecording(false);
      } else {
        recognitionRef.current.start(); // Start recording
        setIsRecording(true);
      }
    }
  };

  const recordAudio = async () => {
    return new Promise((resolve, reject) => {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          const mediaRecorder = new MediaRecorder(stream);
          const audioChunks = [];

          mediaRecorder.ondataavailable = (event) => {
            audioChunks.push(event.data);
          };

          mediaRecorder.onstop = async () => {
            const audioBlob = new Blob(audioChunks, { type: "audio/mpeg" });
            const reader = new FileReader();

            reader.onloadend = () => {
              const base64Audio = reader.result.split(",")[1].toString(); // Extract base64
              resolve(base64Audio);
            };

            reader.onerror = reject;
            reader.readAsDataURL(audioBlob);
          };

          mediaRecorder.start();
          setTimeout(() => mediaRecorder.stop(), 5000); // Record for 5 seconds
        })
        .catch(reject);
    });
  };

  const storenewResponse = {};

  const handleSubmitTeri = async () => {
    if (!query.trim()) {
        setErrorMessage("Question cannot be empty");
        return;
    }

    if (repoType === "") {
        setErrorMessage("Select Repository Type");
        return;
    }

    setLoading(true);
    setErrorMessage("");
    setTextQuery(query);

    const selectedDatabases = Object.keys(databases).filter(
        (db) => databases[db]
    );

    let payload = {
        query: query,
        databases:
            selectedDatabases.length > 0
                ? selectedDatabases
                : ["docs", "image", "audio", "video"],
        feedback: "none",
        model: getCodeByTextOrg(organisationMapping, organisation),
        modelName: getCodeByTextLLM(llmMapping, llm),
        language: language,
    };

    if (repoType === "teri" && pdfDisplay.length > 0 && base64PdfData.length > 0) {
        payload = {
            query: query,
            user_id: cookiesMail.email,
            databases: databasesTeri,
            file: base64PdfData[0],
            cancel: cancel,
            upload: uploadedPdf,
        };
    }

    try {
        const response = await fetch('https://mlmachine.krtrimaiq.ai:5612/query', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (!response.body) {
            throw new Error("No response body received.");
        }
        setLoading(false);
        const stream = response.body;
        const reader = stream.pipeThrough(new TextDecoderStream()).getReader();
        let buffer = "";
        let messageHistory = [];
        let currentFollowUp = "";
        let eventType = "";

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += value;
            const chunks = buffer.split("\n");
            let storenewResponse = {};

            for (const chunk of chunks) {
                if (!chunk.trim()) continue;

                if (chunk.startsWith("event:")) {
                    eventType = chunk.replace("event:", "").trim();
                } else if (chunk.startsWith("data:")) {
                    try {
                        const jsonStr = chunk.replace(/^data:\s*/, "").trim();
                        const data = JSON.parse(jsonStr);

                        if ((eventType === "text_chunk" || eventType === "final_answer") && data.content) {
                            const answer = data.content || "";
                            setResponseAnswer(answer);
                            storenewResponse.answer = answer;

                            if (eventType === "final_answer" && data.graph_url?.length > 0) {
                                storenewResponse.graph_url = data.graph_url;
                            }

                            const sourcesLinks = Array.isArray(data.file_urls)
                                ? data.file_urls
                                    .map((source) =>
                                        source?.file_name && source?.url
                                            ? {
                                                link: source.url.trim(),
                                                displayText: source.file_name.trim(),
                                            }
                                            : null
                                    )
                                    .filter(Boolean)
                                : [];

                            storenewResponse.links = sourcesLinks;
                            storenewResponse.question = query;
                            storenewResponse.imageQuestion = imagePreviews.length > 0 ? imagePreviews : [];
                            storenewResponse.index = index;
                            storenewResponse.language = language;

                            setTeriReferences(Array.isArray(sourcesLinks) ? sourcesLinks : []);

                            const newResponse = {
                                index,
                                question: query,
                                answer: answer || "",
                                followUpQuestion: currentFollowUp,
                                links: sourcesLinks,
                                graph_url: storenewResponse.graph_url || '',
                                imageQuestion: imagePreviews.length > 0 ? imagePreviews : [],
                            };
                            messageHistory.push(newResponse);

                            setResponses(messageHistory.length > 1 ? [messageHistory[messageHistory.length - 1]] : [newResponse]);

                            setIndex((prevIndex) => prevIndex + 1);
                        }

                        if (eventType === "follow_ups") {
                            if (Array.isArray(data.content) && data.content.length > 0) {
                                currentFollowUp = data.content[0] || "";
                                storenewResponse.followUpQuestion = currentFollowUp;
                                setFollowUpTeri(currentFollowUp);
                                if (messageHistory.length > 0) {

                                  messageHistory[messageHistory.length - 1].followUpQuestion = currentFollowUp;
                    
                                  if (messageHistory.length > 1) {
                                    setResponses([messageHistory[messageHistory.length - 1]]);
                                    setResponses([])
                                  }
                                }
                                if (Object.keys(storenewResponse).length > 0) {
                                    setStoredResponse(prevState => [...prevState, storenewResponse]);
                                }
                            }
                        }
                    } catch (err) {
                        console.error("Error parsing JSON chunk:", err);
                    }
                }
            }

            buffer = chunks.pop();
        }
    } catch (error) {
        console.error("Error processing response stream:", error);
    } finally {
        
        setQuery("");
        setUploadedPdf(false);
        setSelectedFiles([]);
        setBase64Data([]);
        setImagePreviews([]);
        setImage(false);
        setFollowQuery("");
    }
};

  const handleDislikeTeri = async (feedback) => {
    setActiveIcon("dislike");
    setLoading(true);

    const selectedDatabases = Object.keys(databases).filter(
      (db) => databases[db]
    );
    // const defaultDatabases = ["docs", "image", "audio", "video"];

    let payload = {
      query: textQuery,
      language: language,
      response: responseAnswer,
      feedbackResponse: feedback,
      feedback: 0,
    };



    const url = new URL("wss://mlmachine.krtrimaiq.ai:5612/usr_feedback");
    const ws = new WebSocket(url);

    let messageHistory = [];
    let currentFollowUp = "";

    ws.onopen = () => {
      setLoading(true);
      messageHistory = [];
      // setResponses([]);
      ws.send(JSON.stringify(payload));
    };

    ws.onmessage = (ev) => {
      try {
        const data = JSON.parse(ev.data);
        setLoading(false);

        if (data.type === "follow_ups") {
          if (Array.isArray(data.content) && data.content.length > 0) {
            currentFollowUp = data.content[0] || "";
            storenewResponse.followUpQuestion = currentFollowUp;

            setStoredResponse(prevState => [...prevState, storenewResponse]);


            if (messageHistory.length > 0) {

              messageHistory[messageHistory.length].followUpQuestion = currentFollowUp;

              if (messageHistory.length > 1) {
                setResponses([messageHistory[messageHistory.length]]);
                setResponses([])
              }
            }
          }
        } else if ((data.type === "text_chunk" || data.type === "final_answer") && data.content) {

          const parser = new DOMParser();
          const doc = parser.parseFromString(data.content, "text/html");
          const answer = doc.querySelector(".answer")?.innerHTML || "kkl";
          if (data.type === 'final_answer') {
            storenewResponse.answer = answer;
            setResponseAnswer(answer)
          }

          if (data.type === 'final_answer' && data.graph_url.length > 0) {
            storenewResponse.graph_url = data.graph_url
          }
          const sourcesLinks = teriReferences.map(source => ({
            link: source.link.trim(),
            displayText: source.displayText.trim()
          }));

          storenewResponse.links = sourcesLinks;
          storenewResponse.question = textQuery;
          storenewResponse.imageQuestion = imagePreviews.length > 0 ? imagePreviews : [];
          storenewResponse.index = index;
          storenewResponse.language = language;
          const newResponse = {
            index,
            question: textQuery,
            answer: answer || "",
            followUpQuestion: followUpTeri,
            links: sourcesLinks,
            graph_url: storenewResponse.graph_url || '',
            imageQuestion: imagePreviews.length > 0 ? imagePreviews : [],
          };

          messageHistory.push(newResponse);

          if (messageHistory.length > 1) {
            setResponses([messageHistory[messageHistory.length - 1]]);
          } else {

            // setStoredResponse([...newResponse])
            setResponses([newResponse]);
          }

          setIndex((prevIndex) => prevIndex + 1);
        }
      } catch (error) {
        console.error("Error processing WebSocket message:", error);
      } finally {
        setQuery("");
        setUploadedPdf(false);
        setSelectedFiles([]);
        setActiveIcon("");
        setBase64Data([]);
        setImagePreviews([]);
        setImage(false);
        setFollowQuery("");

      }
    };
    ws.onerror = (error) => console.error("WebSocket error:", error);
    ws.onclose = () => {

      if (messageHistory.length > 1) {
        setResponses([messageHistory[messageHistory.length - 2]]);
      }
    };
  };

  return (
    <>
      {loading && (
        <div style={overlayStyle}>
          <Spinner />
        </div>
      )}
      <div className="flex gap-4">
        <div className="secondcardWidth">
          <FullCard>
            <div className="subheading text-center mt-2 mb-8">Search</div>
            <div className="mt-8">
              <div className="text-lg font-medium text-indigo-800 text-left my-2">
                Repository
              </div>
              <select
                className="inline-flex w-[17vw] rounded-md border px-4 py-2 text-sm"
                value={repoType}
                onChange={(e) => setRepoType(e.target.value)}
              >
                <option value="krtrimaIQ">KrtrimaIQ</option>
                <option value="oup">Custom File Upload</option>
                <option value="teri">TERI</option>
                {/*<option value="external">External</option>*/}
              </select>
            </div>

            <div className="my-8">
              <div className="text-lg font-medium text-indigo-800 text-left my-2">
                LLM Organisation
              </div>
              <Select
                dropdownData={organisationMapping}
                value={organisation}
                onChange={(e) => {
                  setOrganisation(e.target.value);
                  setLlm(llmMapping[e.target.value][0].text);
                }}
              />
            </div>
            <div className="my-8">
              <div className="text-lg font-medium text-indigo-800 text-left my-2">
                LLM Model
              </div>
              <Select
                dropdownData={llmMapping[organisation]}
                value={llm}
                onChange={(e) => setLlm(e.target.value)}
              />
            </div>
            {repoType === "teri" && (
              <>
                <div className="text-lg font-medium text-indigo-800 text-left my-4">
                  Choose Language
                </div>
                <select
                  className="inline-flex w-[17vw] rounded-md border px-4 py-2 text-sm"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <option value="en">English</option>
                  <option value="hi">हिन्दी</option>
                </select>
              </>
            )}
            {repoType !== "krtrimaIQ" && (
              <>
                <div className="text-lg font-medium text-indigo-800 text-left my-4">
                  Choose Document Type
                </div>
                <div className="px-5">
                  <div
                    className={
                      imagePreviews.length > 0 || repoType === "external"
                        ? "opacity-50"
                        : ""
                    }
                  >
                    {/*{["docs", "image", "audio", "video"].map((type) => (*/}
                    {["docs", "image"].map((type) => (
                      <label key={type} className="flex items-center space-x-2">
                        <input
                          type="checkbox"
                          className="transform scale-150"
                          name={type}
                          onChange={handleCheckboxChange}
                          disabled={
                            imagePreviews.length > 0 || repoType === "other"
                          }
                        />
                        <span>
                          {type.charAt(0).toUpperCase() + type.slice(1)}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </>
            )}
          </FullCard>
        </div>
        {repoType === "krtrimaIQ" && (
          <div className="thirdcardWidth overflow-y-auto h-[90vh]">
            <div className="chat-container" style={{ marginBottom: '10%' }} >
              {data.map((entry, index) => (
                <div className="mb-4" key={index}>
                  <Accordion index={index}>
                    <div key={index} className="chat-message">
                      <div className="subheading text-left px-[2%]">
                        {index === 0
                          ? "Asked Question"
                          : "Asked follow up Question"}
                      </div>
                      <div className="m-5">
                        <div className="flex">
                          <div className="w-1/12">
                            <img
                              src={questionIcon}
                              alt=""
                              width={"50px"}
                              height={"50px"}
                              className=""
                            />
                          </div>
                          <div className="w-11/12 ml-4 bg-white rounded-lg text-xl">
                            <div className="w-full border border-light-purple p-2">
                              {entry.question}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div key={index} className="chat-message">
                      <div className="m-5">
                        <div className="flex">
                          <div className="w-1/12">
                            <img
                              src={ansIcon}
                              alt=""
                              width={"50px"}
                              height={"50px"}
                              className=""
                            />
                          </div>
                          <div className="w-11/12 ml-4 bg-white rounded-lg text-xl">
                            <div className="w-full border border-light-purple p-2">
                              <EseAnswer
                                type={selectedRadioButton}
                                answer={entry}
                                streaming={streaming}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Accordion>
                </div>
              ))}
              <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
                {/* <div className="subheading text-left px-[2%]">
                        {
                            data.length + 1 === 1
                                ? "Enter a Question"
                                : "Enter a different or follow-up Question"
                        }
                    </div> */}
                <div className="mr-10 ml-4 my-6">
                  <div className="flex">
                    <div className="w-full text-lg">
                      <textarea
                        className="w-full border border-[#23479F] rounded-lg p-2"
                        placeholder="Ask your query here....."
                        value={currentQuestion}
                        onChange={(e) => setCurrentQuestion(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault();
                            callEnterpriseSearchAPI(false);
                          }
                        }}
                        rows={1}
                      />
                      <div className="">
                        {errorMessage && (
                          <div className="text-red-600">{errorMessage}</div>
                        )}
                      </div>
                    </div>
                    <div className="ml-4">
                      {loading ? (
                        <div className="overlay">
                          <Spinner />
                        </div>
                      ) : (
                        <Button
                          onClick={() => {
                            callEnterpriseSearchAPI(true);
                          }}
                        >
                          Ask
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {repoType !== "krtrimaIQ" && (
          <div className="thirdcardWidth overflow-y-auto h-[90vh]">
            <div
              className="chat-container"
              style={{
                marginBottom: "10rem",
              }}
            >
              {repoType === "oup" && (
                <>
                  <div className="space-y-2">
                    {storedResponse.map((responseItem, index) => (
                      <Accordion
                        key={responseItem.index}
                        index={responseItem.index}
                      >
                        <div className="chat-message">
                          <div className="subheading text-left px-[2%]">
                            {responseItem.index === 0
                              ? "Asked Question"
                              : "Asked Follow-up Question"}
                          </div>
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={questionIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  <p className="pb-2">
                                    {responseItem.question}
                                  </p>
                                  {responseItem.imageQuestion && (
                                    <img
                                      src={responseItem.imageQuestion}
                                      style={{ width: "90px", height: "auto" }}
                                    />
                                  )}
                                  {/* {imageQuestion && (
                                <img
                                  src={imageQuestion}
                                  style={{ width: "90px", height: "auto" }}
                                />
                              )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat-message">
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={ansIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  {responseItem.answer &&
                                    responseItem.followUpQuestion && (
                                      <div>
                                        <div className="w-full">
                                          <div className="p-0">
                                            {responseItem.answer}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {(responseItem.answer &&
                                    !responseItem.followUpQuestion) ||
                                    (!responseItem.answer &&
                                      responseItem.followUpQuestion) ? (
                                    <>
                                      {responseItem.answer && (
                                        <p className="w-[45vw] text-lg">
                                          {responseItem.answer}
                                        </p>
                                      )}
                                      {responseItem.followUpQuestion && (
                                        <div className="mt-4 text-lg">
                                          {responseItem.followUpQuestion}
                                        </div>
                                      )}
                                    </>
                                  ) : null}
                                  {responseItem.graph_url?.length > 0 && (
                                    <img src={`data:image/png;base64,${responseItem.graph_url}`} alt="Graph" />
                                  )}
                                  {responseItem.links?.length > 0 && (
                                    <>
                                      <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                        {responseItem.language === "hi"
                                          ? "संदर्भ:"
                                          : "References:"}
                                      </div>
                                      {responseItem.links.map((source, idx) => (
                                        <div
                                          key={idx}
                                          className="flex items-center mt-2"
                                        >
                                          <span className="text-blue-500 mr-2">
                                            {idx + 1}.
                                          </span>
                                          <div className="flex-shrink-0">
                                            {getIconByExtension(
                                              source.displayText,
                                              source.link
                                            )}
                                          </div>
                                          <a
                                            href={source.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ml-2 text-blue-500 hover:underline"
                                          >
                                            {source.displayText}
                                          </a>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {typeof responseItem.answer === "string" &&
                            responseItem.answer.trim() &&
                            typeof responseItem.followUpQuestion === "string" &&
                            responseItem.followUpQuestion.trim() && (
                              <div className="mt-4 pl-4">
                                <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                  Suggested Question:
                                </div>
                                <button
                                  onClick={() =>
                                    setQuery(responseItem.followUpQuestion)
                                  }
                                  className="w-full text-left"
                                >
                                  <div className="w-full bg-white rounded-lg">
                                    <div className="w-full border border-light-purple p-2 text-left">
                                      {responseItem.followUpQuestion}
                                    </div>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>
                        <div>
                          <div className="flex justify-start mt-2 mb-2 pl-10">
                            <div className="flex space-x-4">
                              {responseItem.audioPlaying ? (
                                <HiMiniPauseCircle
                                  className="text-red-600 w-6 h-6 cursor-pointer opacity-80"
                                  onClick={(e) => handleStop(index, responseItem.language, e)}
                                />
                              ) : (
                                <HiMiniSpeakerWave
                                  className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                  onClick={(e) => handleVoice(index, responseItem.language, e)}
                                />
                              )}
                              <LuCopy
                                className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                onClick={() => handleCopy(index)}
                              />
                              <AiFillLike
                                className={`${getIconColor(
                                  "like"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={handleLike}
                              />
                              <AiFillDislike
                                className={`${getIconColor(
                                  "dislike"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                          </div>
                        </div>
                        {popoverStates[index] && (
                          <div className="mt-2 p-4 bg-white rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">Tell us more:</p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                "Need More Details",
                                "Incorrect/misleading Information",
                                "Too Complex/Need Simplification",
                                "Too Brief/Need elaboration",
                                "More...",
                              ].map((option) => (
                                <button
                                  key={option}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    if (option === "More...") {
                                      toggleModal(index);
                                    } else {
                                      setFeedbackTxt(option);
                                      togglePopover(index);
                                      handleDislike(option);
                                    }
                                  }}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {modalStates[index] && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <p className="text-gray-700">
                                  Please provide us more feedback:
                                </p>
                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                  onClick={() => closeModal(index)}
                                />
                              </div>
                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder="Your feedback here..."
                                value={feedbackInput}
                                onChange={(e) =>
                                  setFeedbackInput(e.target.value)
                                }
                              ></textarea>
                              <div className="mt-4 flex justify-end">
                                <Button
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislike(feedbackInput);
                                    setFeedbackTxt("");
                                    closeModal(index);
                                  }}
                                >
                                  Submit
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </Accordion>
                    ))}
                  </div>
                  <div className="space-y-2">
                    {responses.map((responseItem, index) => (
                      <Accordion
                        key={responseItem.index}
                        index={responseItem.index}
                      >
                        <div className="chat-message">
                          <div className="subheading text-left px-[2%]">
                            {responseItem.index === 0
                              ? "Asked Question"
                              : "Asked Follow-up Question"}
                          </div>
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={questionIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  <p className="pb-2">
                                    {responseItem.question}
                                  </p>
                                  {responseItem.imageQuestion && (
                                    <img
                                      src={responseItem.imageQuestion}
                                      style={{ width: "90px", height: "auto" }}
                                    />
                                  )}
                                  {/* {imageQuestion && (
                                <img
                                  src={imageQuestion}
                                  style={{ width: "90px", height: "auto" }}
                                />
                              )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat-message">
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={ansIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  {responseItem.answer &&
                                    responseItem.followUpQuestion && (
                                      <div>
                                        <div className="w-full">
                                          <div className="p-0">
                                            {responseItem.answer}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {(responseItem.answer &&
                                    !responseItem.followUpQuestion) ||
                                    (!responseItem.answer &&
                                      responseItem.followUpQuestion) ? (
                                    <>
                                      {responseItem.answer && (
                                        <p className="w-[45vw] text-lg">
                                          {responseItem.answer}
                                        </p>
                                      )}
                                      {responseItem.followUpQuestion && (
                                        <div className="mt-4 text-lg">
                                          {responseItem.followUpQuestion}
                                        </div>
                                      )}
                                    </>
                                  ) : null}
                                  {responseItem.links?.length > 0 && (
                                    <>
                                      <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                        References:
                                      </div>
                                      {responseItem.links.map((source, idx) => (
                                        <div
                                          key={idx}
                                          className="flex items-center mt-2"
                                        >
                                          <span className="text-blue-500 mr-2">
                                            {idx + 1}.
                                          </span>
                                          <div className="flex-shrink-0">
                                            {getIconByExtension(
                                              source.displayText,
                                              source.link
                                            )}
                                          </div>
                                          <a
                                            href={source.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ml-2 text-blue-500 hover:underline"
                                          >
                                            {source.displayText}
                                          </a>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {typeof responseItem.answer === "string" &&
                            responseItem.answer.trim() &&
                            typeof responseItem.followUpQuestion === "string" &&
                            responseItem.followUpQuestion.trim() && (
                              <div className="mt-4 pl-4">
                                <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                  Suggested Question:
                                </div>
                                <button
                                  onClick={() =>
                                    setQuery(responseItem.followUpQuestion)
                                  }
                                  className="w-full text-left"
                                >
                                  <div className="w-full bg-white rounded-lg">
                                    <div className="w-full border border-light-purple p-2 text-left">
                                      {responseItem.followUpQuestion}
                                    </div>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>
                        <div>
                          <div className="flex justify-start mt-2 mb-2 pl-10">
                            <div className="flex space-x-4">
                              {responseItem.audioPlaying ? (
                                <HiMiniPauseCircle
                                  className="text-red-600 w-6 h-6 cursor-pointer opacity-80"
                                  onClick={(e) => handleStop(index, responseItem.language, e)}
                                />
                              ) : (
                                <HiMiniSpeakerWave
                                  className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                  onClick={(e) => handleVoice(index, responseItem.language, e)}
                                />
                              )}
                              <LuCopy
                                className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                onClick={() => handleCopy(index)}
                              />
                              <AiFillLike
                                className={`${getIconColor(
                                  "like"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={handleLike}
                              />
                              <AiFillDislike
                                className={`${getIconColor(
                                  "dislike"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                          </div>
                        </div>
                        {popoverStates[index] && (
                          <div className="mt-2 p-4 bg-white rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">Tell us more:</p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                "Need More Details",
                                "Incorrect/misleading Information",
                                "Too Complex/Need Simplification",
                                "Too Brief/Need elaboration",
                                "More...",
                              ].map((option) => (
                                <button
                                  key={option}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    if (option === "More...") {
                                      toggleModal(index);
                                    } else {
                                      setFeedbackTxt(option);
                                      togglePopover(index);
                                      handleDislike(option);
                                    }
                                  }}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {modalStates[index] && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <p className="text-gray-700">
                                  Please provide us more feedback:
                                </p>
                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                  onClick={() => closeModal(index)}
                                />
                              </div>
                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder="Your feedback here..."
                                value={feedbackInput}
                                onChange={(e) =>
                                  setFeedbackInput(e.target.value)
                                }
                              ></textarea>
                              <div className="mt-4 flex justify-end">
                                <Button
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislike(feedbackInput);
                                    setFeedbackTxt("");
                                    closeModal(index);
                                  }}
                                >
                                  Submit
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </Accordion>
                    ))}
                  </div>

                  <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
                    <div className="mr-10 ml-4 mb-6">
                      <div className="flex">
                        <div className="w-full text-lg">
                          <div className="flex items-center mt-8 w-[55vw] space-x-4">
                            <div>
                              <div className="relative flex-grow bg-[#ffffff] rounded-lg z-90">
                                <div className="relative w-full border-blue-600 rounded-lg ml-6 py-3 flex flex-col space-y-2">
                                  {pdfDisplay.length > 0 && (
                                    <div className="flex space-x-2">
                                      {pdfDisplay.map((src, index) => (
                                        <div
                                          key={index}
                                          className="relative flex items-center space-x-2"
                                        >
                                          {src.type === "pdf" ? (
                                            <a
                                              href={src.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="flex items-center space-x-2"
                                            >
                                              <BsFileEarmarkPdf className="text-red-600 text-2xl" />
                                              <span className="text-sm font-medium">
                                                {src.name}
                                              </span>
                                            </a>
                                          ) : (
                                            <img
                                              src={src}
                                              alt={`Preview ${index}`}
                                              className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                            />
                                          )}

                                          {/* Container for the image/preview and X button */}
                                          <div className="ml-auto">
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="bg-red-600 text-white rounded-full p-1 h-5 w-5 flex items-center justify-center text-xs hover:bg-red-700"
                                            >
                                              X
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <div className="relative flex pr-2">
                                    <FileUploadSearch
                                      className="text-blue-600 cursor-pointer "
                                      onChange={handleFileChange}
                                    />

                                    <textarea
                                      ref={textareaRef}
                                      className="border-none focus:ring-0 focus:outline-none text-lg resize-none ml-2 w-[45vw]"
                                      placeholder="Enter your query here..."
                                      value={query}
                                      onChange={(e) => setQuery(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          e.preventDefault();
                                          handleSubmit();
                                        }
                                      }}
                                      rows={1}
                                      style={{ maxHeight: "20vh" }}
                                    />

                                    <div className="flex items-center gap-2 cursor-pointer">
                                      <div>
                                        <IoMdMic
                                          size={25}
                                          onClick={handleRecordingClick}
                                          className="text-blue-600"
                                        />
                                      </div>

                                      {/* <div >
                                        <FaKeyboard size={25} className="text-blue-600 cursor-pointer" onClick={() => {
                                        setOpenKeyboard(!openKeyboard);
                                      }}/>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <VKeyboard
                                open={openKeyboard}
                                layout={
                                  keyboardLang
                                }
                              /> */}
                            </div>
                            <div className="ml-4">
                              <Button onClick={handleSubmit}>Ask</Button>
                            </div>
                          </div>
                          {errorMessage && (
                            <div className="text-red-600 mt-2">
                              {errorMessage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {repoType === "teri" && (
                <>
                  <div className="space-y-2">
                    {storedResponse.map((responseItem, index) => (
                      <Accordion
                        key={responseItem.index}
                        index={responseItem.index}
                      >
                        <div className="chat-message">
                          <div className="subheading text-left px-[2%]">
                            {responseItem.index === 0
                              ? language === "hindi"
                                ? "प्रश्न पूछा"
                                : "Asked Question"
                              : language === "hindi"
                                ? "अनुवर्ती प्रश्न पूछा"
                                : "Asked Follow-up Question"}
                          </div>

                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={questionIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  <p className="pb-2">
                                    {responseItem.question}
                                  </p>

                                  {/* {responseItem.imageQuestion[0] &&
                                    (responseItem.imageQuestion[0].type ===
                                    "pdf" ? (
                                      <a
                                        href={responseItem.imageQuestion[0].url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center space-x-2"
                                      >
                                        <BsFileEarmarkPdf className="text-red-600 text-2xl" />
                                        <span className="text-sm font-medium">
                                          {responseItem.imageQuestion[0].name}
                                        </span>
                                      </a>
                                    ) : (
                                      <img
                                        src={responseItem.imageQuestion}
                                        alt={`Preview`}
                                        className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                      />
                                    ))} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat-message">
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={ansIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  {responseItem.answer && (
                                    <div>
                                      <div className="w-full">
                                        <div
                                          className={`mt-2 responseanswer-${index}`}
                                          dangerouslySetInnerHTML={{
                                            __html: responseItem.answer,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {responseItem.graph_url?.length > 0 && (
                                    <img src={`data:image/png;base64,${responseItem.graph_url}`} alt="Graph" />
                                  )}
                                  {responseItem.links?.length > 0 && (
                                    <>
                                      <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                        {language === "hi"
                                          ? "संदर्भ:"
                                          : "References:"}
                                      </div>

                                      {responseItem.links.map((source, idx) => (
                                        <div
                                          key={idx}
                                          className="flex items-center mt-2"
                                        >
                                          <span className="text-blue-500 mr-2">
                                            {idx + 1}.
                                          </span>
                                          <div className="flex items-center">
                                            <div className="flex-shrink-0">
                                              {getIconByExtension(
                                                source.displayText,
                                                source.link
                                              )}
                                            </div>
                                            {[
                                              "pdf",
                                              "docx",
                                              "txt",
                                              "jpg",
                                              "png",
                                              "jpeg",
                                            ].includes(
                                              source.displayText
                                                .split(".")
                                                .pop()
                                                .toLowerCase()
                                            ) ? (
                                              <p
                                                onClick={() =>
                                                  teriLink(
                                                    source.link,
                                                    source.displayText
                                                  )
                                                }
                                                className="ml-2 text-blue-500 hover:underline truncate"
                                                style={{ maxWidth: "85vh" }}
                                              >
                                                {source.displayText}
                                              </p>
                                            ) : (
                                              <a
                                                href={source.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ml-2 text-blue-500 hover:underline truncate"
                                                style={{ maxWidth: "85vh" }}
                                              >
                                                {source.displayText}
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {typeof responseItem.answer === "string" &&
                            responseItem.answer.trim() &&
                            typeof responseItem.followUpQuestion === "string" &&
                            responseItem.followUpQuestion.trim() && (
                              <div className="mt-4 pl-4">
                                <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                  {language === "hi"
                                    ? "सुझाया गया प्रश्न:"
                                    : "Suggested Question:"}
                                </div>

                                <button
                                  onClick={() =>
                                    setQuery(responseItem.followUpQuestion)
                                  }
                                  className="w-full text-left"
                                >
                                  <div className="w-full bg-white rounded-lg">
                                    <div className="w-full border border-light-purple p-2 text-left">
                                      {responseItem.followUpQuestion}
                                    </div>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>
                        <div>
                          <div className="flex justify-start mt-2 mb-2 pl-10">
                            <div className="flex space-x-4">
                              {responseItem.audioPlaying ? (
                                <HiMiniPauseCircle
                                  className="text-red-600 w-6 h-6 cursor-pointer opacity-80"
                                  onClick={(e) => handleStop(index, responseItem.language, e)}
                                />
                              ) : (
                                <HiMiniSpeakerWave
                                  className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                  onClick={(e) => handleVoice(index, responseItem.language, e)}
                                />
                              )}
                              <LuCopy
                                className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                onClick={() => handleCopy(index)}
                              />
                              <AiFillLike
                                className={`${getIconColor(
                                  "like"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={handleLike}
                              />
                              <AiFillDislike
                                className={`${getIconColor(
                                  "dislike"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                          </div>
                        </div>
                        {popoverStates[index] && (
                          <div className="mt-2 p-4 bg-white rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">
                                {language === "hi" ? "और अधिक बताएँ:" : "Tell us more:"}
                              </p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                {
                                  en: "Need More Details",
                                  hi: "अधिक विवरण चाहिए",
                                },
                                {
                                  en: "Incorrect/misleading Information",
                                  hi: "ग़लत/भ्रामक जानकारी",
                                },
                                {
                                  en: "Too Complex/Need Simplification",
                                  hi: "बहुत जटिल/सरलीकरण की आवश्यकता है",
                                },
                                {
                                  en: "Too Brief/Need elaboration",
                                  hi: "बहुत संक्षिप्त/विस्तार की आवश्यकता है",
                                },
                                {
                                  en: "More...",
                                  hi: "अधिक...",
                                },
                              ].map(({ en, hi }) => (
                                <button
                                  key={en}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    const selectedOption = language === "hi" ? hi : en;
                                    if (en === "More...") {
                                      toggleModal(index);
                                    } else {
                                      setFeedbackTxt(selectedOption);
                                      togglePopover(index);
                                      handleDislikeTeri(selectedOption);
                                    }
                                  }}
                                >
                                  {language === "hi" ? hi : en}
                                </button>
                              ))}
                            </div>

                          </div>
                        )}

                        {modalStates[index] && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <div className="flex items-center gap-2">
                                  <p className="text-gray-500 text-sm mt-2">
                                    {language === "hi"
                                      ? "कृपया हमें और अधिक प्रतिक्रिया दें:"
                                      : "Please provide us more feedback:"}
                                  </p>
                                  <FaKeyboard
                                    size={15}
                                    className="text-blue-600 cursor-pointer mt-2"
                                    onClick={() => {
                                      setOpenKeyboardModal(!openKeyboardModal);
                                    }}
                                  />
                                </div>

                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer ml-auto"
                                  onClick={() => closeModal(index)}
                                />
                              </div>

                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder={language === "hi" ? "अपनी प्रतिक्रिया यहाँ लिखें..." : "Your feedback here..."}
                                value={feedbackInput}
                                onChange={(e) => setFeedbackInput(e.target.value)}
                              ></textarea>
                              <VKeyboard
                                open={openKeyboardModal}
                                layout={keyboardLang}
                              />
                              <div className="mt-4 flex justify-end">
                                <Button
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislikeTeri(feedbackInput);
                                    setFeedbackTxt("");
                                    closeModal(index);
                                  }}
                                >
                                  {language === "hi" ? "जमा करें" : "Submit"}
                                </Button>

                              </div>
                            </div>
                          </div>
                        )}
                      </Accordion>
                    ))}
                  </div>
                  <div className="space-y-2">
                    {responses.map((responseItem, index) => (
                      <Accordion
                        key={responseItem.index}
                        index={responseItem.index}
                      >
                        <div className="chat-message">
                          <div className="subheading text-left px-[2%]">
                            {responseItem.index === 0
                              ? language === "hindi"
                                ? "प्रश्न पूछा"
                                : "Asked Question"
                              : language === "hindi"
                                ? "अनुवर्ती प्रश्न पूछा"
                                : "Asked Follow-up Question"}
                          </div>

                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={questionIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  <p className="pb-2">
                                    {responseItem.question}
                                  </p>

                                  {responseItem.imageQuestion[0] &&
                                    (responseItem.imageQuestion[0].type ===
                                      "pdf" ? (
                                      <a
                                        href={responseItem.imageQuestion[0].url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="flex items-center space-x-2"
                                      >
                                        <BsFileEarmarkPdf className="text-red-600 text-2xl" />
                                        <span className="text-sm font-medium">
                                          {responseItem.imageQuestion[0].name}
                                        </span>
                                      </a>
                                    ) : (
                                      <img
                                        src={responseItem.imageQuestion}
                                        alt={`Preview`}
                                        className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                      />
                                    ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat-message">
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={ansIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  {responseItem.answer && (
                                    <div>
                                      <div className="w-full">
                                        <div
                                          className={`mt-2 responseanswer-${index}`}
                                          dangerouslySetInnerHTML={{
                                            __html: responseItem.answer,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                  {responseItem.graph_url?.length > 0 && (
                                    <img src={`data:image/png;base64,${responseItem.graph_url}`} alt="Graph" />
                                  )}
                                  {responseItem.links?.length > 0 && (
                                    <>
                                      <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                        {language === "hi"
                                          ? "संदर्भ:"
                                          : "References:"}
                                      </div>

                                      {responseItem.links.map((source, idx) => (
                                        <div
                                          key={idx}
                                          className="flex items-center mt-2"
                                        >
                                          <span className="text-blue-500 mr-2">
                                            {idx + 1}.
                                          </span>
                                          <div className="flex items-center">
                                            <div className="flex-shrink-0">
                                              {getIconByExtension(
                                                source.displayText,
                                                source.link
                                              )}
                                            </div>
                                            {[
                                              "pdf",
                                              "docx",
                                              "txt",
                                              "jpg",
                                              "png",
                                              "jpeg",
                                            ].includes(
                                              source.displayText
                                                .split(".")
                                                .pop()
                                                .toLowerCase()
                                            ) ? (
                                              <p
                                                onClick={() =>
                                                  teriLink(
                                                    source.link,
                                                    source.displayText
                                                  )
                                                }
                                                className="ml-2 text-blue-500 hover:underline truncate"
                                                style={{ maxWidth: "85vh" }}
                                              >
                                                {source.displayText}
                                              </p>
                                            ) : (
                                              <a
                                                href={source.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="ml-2 text-blue-500 hover:underline truncate"
                                                style={{ maxWidth: "85vh" }}
                                              >
                                                {source.displayText}
                                              </a>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {typeof responseItem.answer === "string" &&
                            responseItem.answer.trim() &&
                            typeof responseItem.followUpQuestion === "string" &&
                            responseItem.followUpQuestion.trim() && (
                              <div className="mt-4 pl-4">
                                <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                  {language === "hi"
                                    ? "सुझाया गया प्रश्न:"
                                    : "Suggested Question:"}
                                </div>

                                <button
                                  onClick={() =>
                                    setQuery(responseItem.followUpQuestion)
                                  }
                                  className="w-full text-left"
                                >
                                  <div className="w-full bg-white rounded-lg">
                                    <div className="w-full border border-light-purple p-2 text-left">
                                      {responseItem.followUpQuestion}
                                    </div>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>
                        <div>
                          <div className="flex justify-start mt-2 mb-2 pl-10">
                            <div className="flex space-x-4">
                              {responseItem.audioPlaying ? (
                                <HiMiniPauseCircle
                                  className="text-red-600 w-6 h-6 cursor-pointer opacity-80"
                                  onClick={(e) => handleStop(index, responseItem.language, e)}
                                />
                              ) : (
                                <HiMiniSpeakerWave
                                  className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                  onClick={(e) => handleVoice(index, responseItem.language, e)}
                                />
                              )}
                              <LuCopy
                                className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                onClick={() => handleCopy(index)}
                              />
                              <AiFillLike
                                className={`${getIconColor(
                                  "like"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={handleLike}
                              />
                              <AiFillDislike
                                className={`${getIconColor(
                                  "dislike"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                          </div>
                        </div>
                        {popoverStates[index] && (
                          <div className="mt-2 p-4 bg-white rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">
                                {language === "hi" ? "और अधिक बताएँ:" : "Tell us more:"}
                              </p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                {
                                  en: "Need More Details",
                                  hi: "अधिक विवरण चाहिए",
                                },
                                {
                                  en: "Incorrect/misleading Information",
                                  hi: "ग़लत/भ्रामक जानकारी",
                                },
                                {
                                  en: "Too Complex/Need Simplification",
                                  hi: "बहुत जटिल/सरलीकरण की आवश्यकता है",
                                },
                                {
                                  en: "Too Brief/Need elaboration",
                                  hi: "बहुत संक्षिप्त/विस्तार की आवश्यकता है",
                                },
                                {
                                  en: "More...",
                                  hi: "अधिक...",
                                },
                              ].map(({ en, hi }) => (
                                <button
                                  key={en}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    const selectedOption = language === "hi" ? hi : en;
                                    if (en === "More...") {
                                      toggleModal(index);
                                    } else {
                                      setFeedbackTxt(selectedOption);
                                      togglePopover(index);
                                      handleDislikeTeri(selectedOption);
                                    }
                                  }}
                                >
                                  {language === "hi" ? hi : en}
                                </button>
                              ))}
                            </div>

                          </div>
                        )}

                        {modalStates[index] && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <p className="text-gray-500 text-sm mt-2">
                                  {language === "hi"
                                    ? "कृपया हमें और अधिक प्रतिक्रिया दें:"
                                    : "Please provide us more feedback:"}
                                </p>
                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                  onClick={() => closeModal(index)}
                                />
                              </div>
                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder={language === "hi" ? "अपनी प्रतिक्रिया यहाँ लिखें..." : "Your feedback here..."}
                                value={feedbackInput}
                                onChange={(e) => setFeedbackInput(e.target.value)}
                              ></textarea>

                              <div className="mt-4 flex justify-end">
                                <Button
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislikeTeri(feedbackInput);
                                    setFeedbackTxt("");
                                    closeModal(index);
                                  }}
                                >
                                  {language === "hi" ? "जमा करें" : "Submit"}
                                </Button>

                              </div>
                            </div>
                          </div>
                        )}
                      </Accordion>
                    ))}
                  </div>
                  <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
                    <div className="mr-10 ml-4 mb-6">
                      <div className="flex">
                        <div className="w-full text-lg">
                          <div className="flex items-center mt-8 w-[55vw] space-x-4">
                            <div>
                              <div className="relative flex-grow bg-[#ffffff] rounded-lg z-90">
                                <div className="relative w-full border-blue-600 rounded-lg ml-6 py-3 flex flex-col space-y-2">
                                  {pdfDisplay.length > 0 && (
                                    <div className="flex space-x-2">
                                      {pdfDisplay.map((src, index) => (
                                        <div
                                          key={index}
                                          className="relative flex items-center space-x-2"
                                        >
                                          {src.type === "pdf" ? (
                                            <a
                                              href={src.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="flex items-center space-x-2"
                                            >
                                              <BsFileEarmarkPdf className="text-red-600 text-2xl" />
                                              <span className="text-sm font-medium">
                                                {src.name}
                                              </span>
                                            </a>
                                          ) : (
                                            <img
                                              src={src}
                                              alt={`Preview ${index}`}
                                              className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                            />
                                          )}

                                          {/* Container for the image/preview and X button */}
                                          <div className="ml-auto">
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="bg-red-600 text-white rounded-full p-1 h-5 w-5 flex items-center justify-center text-xs hover:bg-red-700"
                                            >
                                              X
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <div className="relative flex pr-2">
                                    {/*<FileUploadSearch*/}
                                    {/*  className="text-blue-600 cursor-pointer "*/}
                                    {/*  onChange={handleFileChange}*/}
                                    {/*/>*/}

                                    <textarea
                                      ref={textareaRef}
                                      className="border-none focus:ring-0 focus:outline-none text-lg resize-none ml-2 w-[44vw]"
                                      placeholder={
                                        language === "hi"
                                          ? "अपनी क्वेरी यहां दर्ज करें..."
                                          : "Enter your query here..."
                                      }
                                      value={query}
                                      onChange={(e) => setQuery(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          e.preventDefault();
                                          if (pdfDisplay.length > 0) {
                                            handleSubmit();
                                          } else {
                                            handleSubmitTeri();
                                          }
                                        }
                                      }}

                                      rows={1}
                                      style={{ maxHeight: "20vh" }}
                                    />

                                    <div className="flex items-center gap-2 cursor-pointer">
                                      <div>
                                        <IoMdMic
                                          size={25}
                                          onClick={handleRecordingClick}
                                          className="text-blue-600"
                                        />
                                      </div>

                                      <div>
                                        <FaKeyboard
                                          size={25}
                                          className="text-blue-600 cursor-pointer"
                                          onClick={() => {
                                            setOpenKeyboard(!openKeyboard);
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <VKeyboard
                                open={openKeyboard}
                                layout={keyboardLang}
                              />
                            </div>
                            <div className="ml-4">
                              {language === "en" && (
                                <Button onClick={() => (pdfDisplay.length > 0 ? handleSubmit() : handleSubmitTeri())}>
                                  Ask
                                </Button>
                              )}
                              {language === "hi" && (
                                <Button onClick={() => (pdfDisplay.length > 0 ? handleSubmit() : handleSubmitTeri())}>
                                  खोज
                                </Button>
                              )}
                            </div>
                          </div>
                          {errorMessage && (
                            <div className="text-red-600 mt-2">
                              {errorMessage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {repoType === "external" && (
                <>
                  <div className="space-y-2">
                    {responses.map((responseItem, index) => (
                      <Accordion
                        key={responseItem.index}
                        index={responseItem.index}
                      >
                        <div className="chat-message">
                          <div className="subheading text-left px-[2%]">
                            {responseItem.index === 0
                              ? "Asked Question"
                              : "Asked Follow-up Question"}
                          </div>
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={questionIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  <p className="pb-2">
                                    {responseItem.question}
                                  </p>
                                  {responseItem.imageQuestion && (
                                    <img
                                      src={responseItem.imageQuestion}
                                      style={{ width: "90px", height: "auto" }}
                                    />
                                  )}
                                  {/* {imageQuestion && (
                                <img
                                  src={imageQuestion}
                                  style={{ width: "90px", height: "auto" }}
                                />
                              )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="chat-message">
                          <div className="m-5">
                            <div className="flex">
                              <div className="w-1/12">
                                <img
                                  src={ansIcon}
                                  alt=""
                                  width={"50px"}
                                  height={"50px"}
                                />
                              </div>
                              <div className="w-11/12 ml-2 bg-white rounded-lg text-xl">
                                <div className="w-full border border-light-purple p-2">
                                  {responseItem.answer &&
                                    responseItem.followUpQuestion && (
                                      <div>
                                        <div className="w-full">
                                          <div className="p-0">
                                            {responseItem.answer}
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {(responseItem.answer &&
                                    !responseItem.followUpQuestion) ||
                                    (!responseItem.answer &&
                                      responseItem.followUpQuestion) ? (
                                    <>
                                      {responseItem.answer && (
                                        <p className="w-[45vw] text-lg">
                                          {responseItem.answer}
                                        </p>
                                      )}
                                      {responseItem.followUpQuestion && (
                                        <div className="mt-4 text-lg">
                                          {responseItem.followUpQuestion}
                                        </div>
                                      )}
                                    </>
                                  ) : null}
                                  {responseItem.links?.length > 0 && (
                                    <>
                                      <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                        References:
                                      </div>
                                      {responseItem.links.map((source, idx) => (
                                        <div
                                          key={idx}
                                          className="flex items-center mt-2"
                                        >
                                          <span className="text-blue-500 mr-2">
                                            {idx + 1}.
                                          </span>
                                          <div className="flex-shrink-0">
                                            {getIconByExtension(
                                              source.displayText,
                                              source.link
                                            )}
                                          </div>
                                          <a
                                            href={source.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="ml-2 text-blue-500 hover:underline"
                                          >
                                            {source.displayText}
                                          </a>
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          {typeof responseItem.answer === "string" &&
                            responseItem.answer.trim() &&
                            typeof responseItem.followUpQuestion === "string" &&
                            responseItem.followUpQuestion.trim() && (
                              <div className="mt-4 pl-4">
                                <div className="text-lg font-bold text-indigo-800 text-left my-2">
                                  Suggested Question:
                                </div>
                                <button
                                  onClick={() =>
                                    setQuery(responseItem.followUpQuestion)
                                  }
                                  className="w-full text-left"
                                >
                                  <div className="w-full bg-white rounded-lg">
                                    <div className="w-full border border-light-purple p-2 text-left">
                                      {responseItem.followUpQuestion}
                                    </div>
                                  </div>
                                </button>
                              </div>
                            )}
                        </div>
                        <div>
                          <div className="flex justify-start mt-2 mb-2 pl-10">
                            <div className="flex space-x-4">
                              {responseItem.audioPlaying ? (
                                <HiMiniPauseCircle
                                  className="text-red-600 w-6 h-6 cursor-pointer opacity-80"
                                  onClick={(e) => handleStop(index, responseItem.language, e)}
                                />
                              ) : (
                                <HiMiniSpeakerWave
                                  className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                  onClick={(e) => handleVoice(index, responseItem.language, e)}
                                />
                              )}
                              <LuCopy
                                className="text-gray-600 w-6 h-6 cursor-pointer opacity-50"
                                onClick={() => handleCopy(index)}
                              />
                              <AiFillLike
                                className={`${getIconColor(
                                  "like"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={handleLike}
                              />
                              <AiFillDislike
                                className={`${getIconColor(
                                  "dislike"
                                )} w-6 h-6 cursor-pointer opacity-50`}
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                          </div>
                        </div>
                        {popoverStates[index] && (
                          <div className="mt-2 p-4 bg-white rounded-md border border-gray-200 w-[80vh]">
                            <div className="flex justify-between items-center mb-2">
                              <p className="text-gray-700">Tell us more:</p>
                              <LuX
                                className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                onClick={() => togglePopover(index)}
                              />
                            </div>
                            <div className="flex flex-wrap gap-2">
                              {[
                                "Need More Details",
                                "Incorrect/misleading Information",
                                "Too Complex/Need Simplification",
                                "Too Brief/Need elaboration",
                                "More...",
                              ].map((option) => (
                                <button
                                  key={option}
                                  className="bg-gray-100 hover:bg-gray-200 text-gray-800 py-1 px-2 rounded cursor-pointer"
                                  style={{
                                    flex: "1 1 calc(33.33% - 8px)",
                                    minWidth: "35%",
                                  }}
                                  onClick={() => {
                                    if (option === "More...") {
                                      toggleModal(index);
                                    } else {
                                      setFeedbackTxt(option);
                                      togglePopover(index);
                                      handleDislike(option);
                                    }
                                  }}
                                >
                                  {option}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {modalStates[index] && (
                          <div className="fixed inset-0 z-20 flex items-center justify-center bg-black bg-opacity-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-[50vh]">
                              <div className="flex justify-between items-center mb-4">
                                <p className="text-gray-700">
                                  Please provide us more feedback:
                                </p>
                                <LuX
                                  className="text-gray-500 hover:text-gray-800 cursor-pointer"
                                  onClick={() => closeModal(index)}
                                />
                              </div>
                              <textarea
                                rows="2"
                                className="w-full p-2 border border-gray-300 rounded focus:outline-none focus:border-blue-400"
                                placeholder="Your feedback here..."
                                value={feedbackInput}
                                onChange={(e) =>
                                  setFeedbackInput(e.target.value)
                                }
                              ></textarea>
                              <div className="mt-4 flex justify-end">
                                <Button
                                  onClick={() => {
                                    setFeedbackTxt(feedbackInput);
                                    handleDislike(feedbackInput);
                                    setFeedbackTxt("");
                                    closeModal(index);
                                  }}
                                >
                                  Submit
                                </Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </Accordion>
                    ))}
                  </div>

                  <div className="fixed bottom-0 thirdCard bg-[#e5eeff]">
                    <div className="mr-10 ml-4 mb-6">
                      <div className="flex">
                        <div className="w-full text-lg">
                          <div className="flex items-center mt-8 w-[55vw] space-x-4">
                            <div>
                              <div className="relative flex-grow bg-[#ffffff] rounded-lg z-90">
                                <div className="relative w-full border-blue-600 rounded-lg ml-6 py-3 flex flex-col space-y-2">
                                  {pdfDisplay.length > 0 && (
                                    <div className="flex space-x-2">
                                      {pdfDisplay.map((src, index) => (
                                        <div
                                          key={index}
                                          className="relative flex items-center space-x-2"
                                        >
                                          {src.type === "pdf" ? (
                                            <a
                                              href={src.url}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              className="flex items-center space-x-2"
                                            >
                                              <BsFileEarmarkPdf className="text-red-600 text-2xl" />
                                              <span className="text-sm font-medium">
                                                {src.name}
                                              </span>
                                            </a>
                                          ) : (
                                            <img
                                              src={src}
                                              alt={`Preview ${index}`}
                                              className="h-16 w-16 object-cover rounded-lg border-2 border-blue-600"
                                            />
                                          )}

                                          {/* Container for the image/preview and X button */}
                                          <div className="ml-auto">
                                            <button
                                              onClick={() =>
                                                handleRemoveFile(index)
                                              }
                                              className="bg-red-600 text-white rounded-full p-1 h-5 w-5 flex items-center justify-center text-xs hover:bg-red-700"
                                            >
                                              X
                                            </button>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                  <div className="relative flex pr-2">
                                    <FileUploadSearch
                                      className="text-blue-600 cursor-pointer "
                                      onChange={handleFileChange}
                                    />

                                    <textarea
                                      ref={textareaRef}
                                      className="border-none focus:ring-0 focus:outline-none text-lg resize-none ml-2 w-[45vw]"
                                      placeholder="Enter your query here..."
                                      value={query}
                                      onChange={(e) => setQuery(e.target.value)}
                                      onKeyDown={(e) => {
                                        if (e.key === "Enter" && !e.shiftKey) {
                                          e.preventDefault();
                                          handleSubmit();
                                        }
                                      }}
                                      rows={1}
                                      style={{ maxHeight: "20vh" }}
                                    />

                                    <div className="flex items-center gap-2 cursor-pointer">
                                      <div>
                                        <IoMdMic
                                          size={25}
                                          onClick={handleRecordingClick}
                                          className="text-blue-600"
                                        />
                                      </div>

                                      {/* <div >
                                        <FaKeyboard size={25} className="text-blue-600 cursor-pointer" onClick={() => {
                                        setOpenKeyboard(!openKeyboard);
                                      }}/>
                                      </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* <VKeyboard
                                open={openKeyboard}
                                layout={
                                  keyboardLang
                                }
                              /> */}
                            </div>
                            <div className="ml-4">
                              <Button onClick={handleSubmit}>Ask</Button>
                            </div>
                          </div>
                          {errorMessage && (
                            <div className="text-red-600 mt-2">
                              {errorMessage}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </>

  );
};

export default EnterpriseSearch;
